module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABwAAAAcCAYAAAByDd+UAAAA+klEQVRIie2WMUoEQRBFX60yCLsiqMGCycQmXsRwD+AVxNgLCAMbu5E3Ec9gvpgIgiDMhILPZIJBWZgemRZxf1Td8Ot109VFoRZqpdaOp7plFLRBLlWh1sA+edSEaiYYAJOcsF8B7v7A+wY8AjvAGTDt5RpQaR/qlVp0ctz2NQ+54U1EVF/2Zn3NQ6r0JCKeAdQlcA4cAwdjAF8iYt7CjoDXxMMmFc0DcNdZvwOXwCFw3TtLQrEsN/jLhBym/MNTddEBzdQLYLHZ8l2pb/gUEWULLIF1Cgz+Q2vbAv8+MLV5z9X7Nt4bAtyOGKMAm4y8ZgKsMgJXmHnU/wSvhEfL5xAnBgAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/facebook.png
// module id = 872
// module chunks = 93